// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fc627820","239":"b08bf4b7","455":"92051ce7"}[chunkId] + ".chunk.js";
};